import React, { FC } from 'react';
import LastRefreshed from '@/components/LastRefreshed';
import { Small } from '@trevor/ui-components';
import styled from 'styled-components';

type RefreshInfoProps = {
  lastRefreshed: Maybe<string>;
  frequencyRefresh: string;
};

const RefreshInfoLabel = styled(Small)`
  color: var(--color-interface-content-lighter);
  text-align: right;
`;

export const RefreshInfo: FC<RefreshInfoProps> = ({
  lastRefreshed,
  frequencyRefresh,
}) => {
  return (
    <RefreshInfoLabel>
      Refreshes {frequencyRefresh}
      <br />
      Last refreshed:&nbsp;
      {lastRefreshed ? (
        <LastRefreshed lastRefreshed={lastRefreshed} />
      ) : (
        'Never'
      )}
    </RefreshInfoLabel>
  );
};
